module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center1",
    staticStyle: {
      "margin-top": "6em"
    }
  }, [_c('strong', {
    staticClass: "futur_bold"
  }, [_vm._v("Other Li"), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/1.jpg"
    }
  }), _vm._v(" books by Mark Tatulli")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "futur_ital"
  }, [_vm._v("Liō: Happiness Is a Squishy Cephalopod")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "futur_ital"
  }, [_vm._v("Silent But Deadly")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "futur_ital"
  }, [_vm._v("Liō’s Astonishing Tales")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "futur_ital"
  }, [_vm._v("There’s Corpses Everywhere")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "futur_ital"
  }, [_vm._v("Reheated Liō")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ab97462","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/a1.vue
// module id = 60
// module chunks = 0